// Pace.js shows the top loading bar but does not know when Turbolinks has
// finished rendering (especially on browser back/forward cache restores).
// Without this, the bar can stay stuck partway even though the page loaded.

function finishPaceProgress() {
  if (!window.Pace || typeof window.Pace.stop !== "function") return;

  window.Pace.stop();
}

document.addEventListener("turbolinks:load", finishPaceProgress);
document.addEventListener("turbolinks:before-cache", finishPaceProgress);
